import { render } from "./px-footer.vue?vue&type=template&id=1db6f1cd&ts=true"
import script from "./px-footer.vue?vue&type=script&lang=ts"
export * from "./px-footer.vue?vue&type=script&lang=ts"

import "./px-footer.vue?vue&type=style&index=0&id=1db6f1cd&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__